import n from "react";
const c = (o = !1) => {
  const [e, t] = n.useState(o);
  return { open: e, onToggleClick: () => t(!e) };
};
export {
  c as useToggle
};
